<div class="row">
    <div class="col-12">
        <table class="table table-sm ">
            <thead>
                <th>Data</th>
                <th>Azione</th>
                <th>Utente</th>
                <td></td>
            </thead>
            <tbody>
                <tr *ngFor="let l of logs">
                    <td>{{l.created | date:"dd/MM/yyyy HH:mm:ss"}}</td>
                    <td>
                        <span *ngIf="l.subject=='new'">Creato</span>
                        <span *ngIf="l.subject=='modified'">Modificato</span>
                        <span *ngIf="l.subject=='delete'">Eliminato</span>
                    </td>
                    <td>{{l.username}}</td>
                    <td>
                        <button class="btn btn-sm btn-secondary" (click)="openDetail(l)"><i class="fa fa-pencil-alt"></i></button>
                    </td>
                </tr>
            </tbody>
        </table>
        <button class="btn btn-success mt-2" (click)="openDetail()"><i class="fa fa-plus mr-2"></i>Aggiungi</button>
    </div>
</div>


<ng-template #modalDetail>
    <div class="modal-header">
        Dettaglio Log
        <div class="card-tools">
            <button type="button" class="btn btn-tool" (click)="closeDetail()" >
                <i class="fas fa-times"></i>
            </button>
        </div>
    </div>
    <div class="modal-body">
        <label>Oggetto</label>
        <input type="text" class="form-control" [(ngModel)]="log.subject">
        <label>Descrizione</label>
        <textarea  class="form-control" [(ngModel)]="log.description"></textarea>

        <app-activities-preview *ngIf="log.record" [record]="log.record"></app-activities-preview>
       

    </div>
    <div class="modal-footer">
        <button class="btn btn-secondary" (click)="closeDetail()">Annulla</button>
        <button class="btn btn-success" (click)="save()">Salva</button>        
    </div>
</ng-template>